"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalFooterButton = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _spacing = require("../../../constants/spacing");
var _button = require("../../button");
const ModalFooterButton = (0, _styled.default)(_button.Button)`
    flex: 1 0 auto;
    margin-left: ${_spacing.sizes.small}px;
`;
exports.ModalFooterButton = ModalFooterButton;
//# sourceMappingURL=FooterButton.js.map